import { AxiosError, AxiosRequestConfig, AxiosResponse } from "axios";
import { loadConfig } from "../../configuration/config";
import AxiosInstance from "../../helpers/axiosInstance";
import { ApiError } from "./errors";

export const postApi = async <Response = unknown, Data = unknown>(
  url: string,
  data?: Data,
  config?: AxiosRequestConfig<Data>
): Promise<AxiosResponse<Response | undefined>> => {
  try {
    const baseUrl = (await loadConfig()).ApiUrl;
    const instance = await AxiosInstance();
    return await instance.post(`${baseUrl}${url}`, data, {
      ...config,
      params: formatParams(config?.params),
    });
  } catch (error: unknown) {
    handleError(error);
  }
};

export function handleError(error: unknown): never {
  console.error(error);
  if (error instanceof AxiosError) {
    throw new ApiError(error);
  }
  throw error;
}

export const getApi = async <Response = unknown, Data = unknown>(
  url: string,
  config?: AxiosRequestConfig<Data>
): Promise<AxiosResponse<Response | undefined>> => {
  try {
    const baseUrl = (await loadConfig()).ApiUrl;
    const instance = await AxiosInstance();
    return await instance.get(`${baseUrl}${url}`, {
      ...config,
      params: formatParams(config?.params),
    });
  } catch (error: unknown) {
    handleError(error);
    throw error;
  }
};

export const putApi = async <Response = unknown, Data = unknown>(
  url: string,
  data?: Data,
  config?: AxiosRequestConfig<Data>
): Promise<AxiosResponse<Response | undefined>> => {
  try {
    const baseUrl = (await loadConfig()).ApiUrl;
    const instance = await AxiosInstance();
    return await instance.put(`${baseUrl}${url}`, data, {
      ...config,
      params: formatParams(config?.params),
    });
  } catch (error: unknown) {
    handleError(error);
    throw error;
  }
};

export const deleteApi = async <Response = unknown, Data = unknown>(
  url: string,
  config?: AxiosRequestConfig<Data>
): Promise<AxiosResponse<Response | undefined>> => {
  try {
    const baseUrl = (await loadConfig()).ApiUrl;
    const instance = await AxiosInstance();
    return await instance.delete(`${baseUrl}${url}`, {
      ...config,
      params: formatParams(config?.params),
    });
  } catch (error: unknown) {
    handleError(error);
    throw error;
  }
};

export const patchApi = async <Response = unknown, Data = unknown>(
  url: string,
  data?: Data,
  config?: AxiosRequestConfig<Data>
): Promise<AxiosResponse<Response | undefined>> => {
  try {
    const baseUrl = (await loadConfig()).ApiUrl;
    const instance = await AxiosInstance();
    return await instance.patch(`${baseUrl}${url}`, data, {
      ...config,
      params: formatParams(config?.params),
    });
  } catch (error: unknown) {
    handleError(error);
    throw error;
  }
};

const formatParams = (
  params?: Record<string, unknown>
): Record<string, unknown> | undefined => {
  if (!params) {
    return undefined;
  }

  const formatted: Record<string, unknown> = {};

  for (const key in params) {
    if (Array.isArray(params[key])) {
      formatted[key] = JSON.stringify(params[key]);
    } else {
      formatted[key] = params[key];
    }
  }

  return formatted;
};
